import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AwsRedHomeService } from 'src/app/services/main/home/red-home/aws-red-home.service';
import { GlobalService } from 'src/app/services/global.service';
import {ConfirmationService, MessageService} from 'primeng/api';
import { CompanyService } from 'src/app/services/company.service';

@Component({
  selector: 'app-list-business',
  templateUrl: './list-business.component.html',
  styleUrls: ['./list-business.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class ListBusinessComponent implements OnInit {

  @Input() data = null;
  @Output() close = new EventEmitter<boolean>();
  @Output() updateCompany = new EventEmitter<object>();

  listHubs = [];
  loading = false;
  desktop = true;
  constructor(
    private router: Router,
    private aws: AwsRedHomeService,
    private globalService: GlobalService,
    private companyService: CompanyService
    ) { 
      this.desktop = this.globalService.desktop;
    }

  ngOnInit(): void {

  }

  openCompany(data){
    this.close.emit(true);
    this.redirectPreference(data);
  }

  async redirectPreference(data){
    let plan:any = await new Promise((resolve, reject) => {
      this.companyService.getPlans('premium').subscribe((res) => {
        resolve(res);
      });
    });
    let sections = plan['sections'];
    let accessDirect = data['accessDirect'];
    if(accessDirect?.length > 0){
      let url = sections.find(c => c.id === accessDirect);
      if(url){
        this.router.navigate([`/home/company/${data['id']}/${url['href']}`]);
      }else{
        this.router.navigate([`/home/company/${data['id']}`]);
      }
    }else{
      this.router.navigate([`/home/company/${data['id']}`]);
    }
  }

  openHub(item){
    this.close.emit(true);
    if(this.desktop){
      window.open('/home/hub/'+item.id+'/'+this.data['id'], '_blank');
    }else{
      this.router.navigate([`/home/hub/${item.id}/${this.data['id']}`]);
    }
  }

  getColorScale(number) {
    if (number >= 0 && number <= 45) {
      return 'red';
    } else if (number > 45 && number <= 55) {
      return 'orange';
    } else if (number > 55 && number <= 65) {
      return 'yellow';
    } else if (number > 65 && number <= 85) {
      return '#74e73b';
    } else if (number > 85 && number <= 100) {
      return 'green';
    } else {
      return 'red'
    }
  }

  update(data){
    this.updateCompany.emit(data)
  }
}
